import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

function AllergiesInfo() {
  const [content, setContent] = React.useState<string>('');

  React.useEffect(() => {
    fetch('/allergie_antibiotici.md')
      .then(response => response.text())
      .then(text => setContent(text))
      .catch(err => console.error('Error loading allergie:', err));
  }, []);

  return (
    <Accordion elevation={2} sx={{ my: 0 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Allergie agli Antibiotici</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{
          '& p': { marginBottom: 2, fontSize: '0.875rem' },
          '& strong': { fontWeight: 600 },
          '& ul': { marginTop: 0, marginBottom: 2, paddingLeft: 3 },
          '& li': { fontSize: '0.875rem' },
        }}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {content}
          </ReactMarkdown>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}

export default AllergiesInfo;
